import { CloseOutlined, SaveOutlined, UploadOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Switch,
  Typography,
  Upload,
} from "antd";
import dayjs from "dayjs";
import { CKEditorComponent } from "../../../../components/CKEditor/CKEditor";

const { TextArea } = Input;

const { Title } = Typography;

const priorityOptions = [
  { value: "low", label: "Thấp" },
  { value: "normal", label: "Bình thường" },
  { value: "high", label: "Cao" },
  { value: "urgent", label: "Khẩn cấp" },
];

export function AddEditAnnouncementForm({ loading, form, onSubmit, onCancel }) {
  const handleSubmit = (values) => {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("isActive", values.isActive || false);
    formData.append("priority", values.priority || "normal");
    formData.append("isPinned", values.isPinned || false);

    if (values.excerpt) formData.append("excerpt", values.excerpt);
    if (values.content) formData.append("content", values.content);
    if (values.image && values.image.length > 0) {
      formData.append("image", values.image[0].originFileObj);
    }
    if (values.imageUrl) {
      formData.append("imageUrl", values.imageUrl);
    }
    if (values.startDate && values.endDate) {
      formData.append("startDate", values.startDate.toISOString());
      formData.append("endDate", values.endDate.toISOString());
    }

    onSubmit(formData);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      autoComplete="off"
    >
      <Row gutter={[20, 20]}>
        <Col xs={24} lg={16}>
          <Card
            style={{
              borderRadius: 12,
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              height: "100%",
            }}
            bodyStyle={{ padding: "24px" }}
          >
            <Title level={5} style={{ margin: "0 0 24px 0" }}>
              Thông tin cơ bản
            </Title>

            <Form.Item
              label="Tiêu đề"
              name="title"
              rules={[
                { required: true, message: "Vui lòng nhập tiêu đề!" },
                {
                  min: 2,
                  max: 200,
                  message: "Tiêu đề phải từ 2 đến 200 ký tự!",
                },
              ]}
            >
              <TextArea
                placeholder="Nhập tiêu đề thông báo"
                rows={2}
                size="large"
                showCount
                maxLength={200}
              />
            </Form.Item>

            <Form.Item label="Nội dung chi tiết" name="content">
              <CKEditorComponent />
            </Form.Item>
          </Card>
        </Col>

        <Col xs={24} lg={8}>
          <Card
            style={{
              borderRadius: 12,
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              marginBottom: 20,
            }}
            bodyStyle={{ padding: "24px" }}
          >
            <Title level={5} style={{ margin: "0 0 24px 0" }}>
              Cài đặt hiển thị
            </Title>

            <Form.Item
              label="Trạng thái"
              name="isActive"
              initialValue={true}
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Form.Item
              label="Mức độ ưu tiên"
              name="priority"
              initialValue="normal"
            >
              <Select options={priorityOptions} size="large" />
            </Form.Item>

            <Form.Item
              label="Ghim lên đầu"
              name="isPinned"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Row gutter={[16, 16]}>
              <Col xs={24} lg={12}>
                <Form.Item
                  label="Ngày bắt đầu"
                  name="startDate"
                  rules={[
                    { required: true, message: "Vui lòng chọn ngày bắt đầu!" },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    disabled={loading}
                    placeholder="Chọn ngày"
                    showTime={{ format: "HH:mm" }}
                    format="DD/MM/YYYY HH:mm"
                    disabledDate={(current) =>
                      current && current < dayjs().startOf("day")
                    }
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} lg={12}>
                <Form.Item
                  label="Ngày kết thúc"
                  name="endDate"
                  rules={[
                    { required: true, message: "Vui lòng chọn ngày kết thúc!" },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    disabled={loading}
                    placeholder="Chọn ngày"
                    showTime={{ format: "HH:mm" }}
                    format="DD/MM/YYYY HH:mm"
                    disabledDate={(current) => {
                      const startDateValue = form.getFieldValue("startDate");
                      if (startDateValue) {
                        return (
                          current &&
                          current < dayjs(startDateValue).startOf("day")
                        );
                      }
                      return current && current < dayjs().startOf("day");
                    }}
                    size="large"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card
            style={{
              borderRadius: 12,
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              marginBottom: 20,
            }}
            bodyStyle={{ padding: "24px" }}
          >
            <Title level={5} style={{ margin: "0 0 24px 0" }}>
              Hình ảnh
            </Title>

            <Form.Item
              label="Cách chọn hình ảnh"
              name="imageType"
              initialValue="upload"
            >
              <Radio.Group>
                <Radio.Button value="upload">Upload</Radio.Button>
                <Radio.Button value="url">URL</Radio.Button>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.imageType !== currentValues.imageType
              }
            >
              {({ getFieldValue }) =>
                getFieldValue("imageType") === "upload" ? (
                  <Form.Item
                    name="image"
                    valuePropName="fileList"
                    getValueFromEvent={(e) => e?.fileList}
                  >
                    <Upload
                      listType="picture-card"
                      maxCount={1}
                      beforeUpload={() => false}
                      accept="image/*"
                    >
                      <div style={{ padding: 8 }}>
                        <UploadOutlined
                          style={{ fontSize: 28, color: "#999" }}
                        />
                        <div style={{ marginTop: 8, color: "#999" }}>
                          Chọn hình
                        </div>
                      </div>
                    </Upload>
                  </Form.Item>
                ) : (
                  <Form.Item name="imageUrl">
                    <Input
                      placeholder="https://example.com/image.jpg"
                      size="large"
                    />
                  </Form.Item>
                )
              }
            </Form.Item>
          </Card>
        </Col>
      </Row>

      <Space style={{ width: "100%", justifyContent: "flex-end" }} size={12}>
        <Button
          icon={<CloseOutlined />}
          size="large"
          onClick={onCancel}
          disabled={loading}
        >
          Hủy
        </Button>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          size="large"
          htmlType="submit"
          loading={loading}
        >
          Lưu thông báo
        </Button>
      </Space>
    </Form>
  );
}
